export interface Article {
  id: number;
  title: string;
  slug: string;
  category: string;
  excerpt: string;
  content: string;
  image: string;
  imageWidth: number;
  imageHeight: number;
  author: string;
  publishDate: string;
  views: number;
  comments: number;
  tags: string[];
  isHot: boolean;
  isExclusive: boolean;
  isVideo: boolean;
}

export const articles: Article[] = [
  {
    id: 1,
    title: '独家爆料：某顶流明星深夜密会神秘人士，疑似恋情曝光',
    slug: 'exclusive-top-star-secret-date',
    category: 'yule',
    excerpt: '据可靠消息源透露，某一线顶流明星近日被拍到深夜独自前往某高档公寓，与一神秘人士密会长达四小时。知情人爆料称两人已交往数月，该明星团队暂未回应。',
    content: `<p>娱乐圈再爆重磅猛料！据多位目击者证实，某一线顶流明星近期频繁出入京城某高档小区，行为低调但仍有蛛丝马迹可循。</p>
<p>知情人士向爆料专区独家透露，该明星与神秘人士的交往已持续数月之久。两人通过共同好友介绍认识，一见如故，感情迅速升温。</p>
<p>"他们平时非常小心，从来不在公共场合同框，但私底下的互动频率非常高，"该知情人士表示，"圈内不少人都知道这件事，只是碍于各方利益，没人敢公开说。"</p>
<p>记者试图联系该明星工作室求证，截至发稿前尚未收到回复。多位娱乐圈资深人士分析认为，如果此事属实，将对明星的商业价值产生重大影响。</p>
<p>值得关注的是，该明星近期在社交媒体上的动态也出现了一些微妙变化——频繁发布一些隐晦的情感类文案，被粉丝解读为"恋爱信号"。而在最近一次公开活动中，该明星面对媒体的感情提问选择了回避，更增添了外界猜测。</p>
<p>爆料专区将持续关注此事进展，第一时间为您带来最新消息。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Silhouette%20of%20two%20people%20meeting%20secretly%20at%20night%20in%20front%20of%20luxury%20apartment%20building%2C%20cinematic%20lighting%2C%20mysterious%20atmosphere%2C%20paparazzi%20style%20photography%2C%20warm%20street%20lights%2C%20film%20grain%20texture%2C%20soft%20focus%20background&width=1600&height=900&seq=article-01&orientation=landscape',
    imageWidth: 1600,
    imageHeight: 900,
    author: '爆料君',
    publishDate: '2026-08-04',
    views: 1289300,
    comments: 5621,
    tags: ['顶流明星', '恋情曝光', '独家爆料', '娱乐圈'],
    isHot: true,
    isExclusive: true,
    isVideo: false,
  },
  {
    id: 2,
    title: '某知名互联网大厂被曝大规模裁员，涉及多个核心业务线',
    slug: 'tech-giant-mass-layoff-exposed',
    category: 'keji',
    excerpt: '内部员工爆料称，某头部互联网公司正在执行新一轮人员优化计划，涉及研发、运营、市场等多个部门。据称本次裁员比例高达15%，赔偿方案引发员工不满。',
    content: `<p>科技圈再传震动消息！某知名互联网大厂被内部员工爆料正在进行大规模人员裁减，涉及范围之广令人咋舌。</p>
<p>据多位匿名员工透露，此次裁员计划被称为"组织架构优化"，实际涉及研发、运营、市场、产品等多个核心业务线，波及比例约为15%。</p>
<p>"上周五突然被HR叫去谈话，整个部门三分之一的人都要走，"一位被裁员工告诉爆料专区，"公司给出的理由是需要降本增效，但我们部门的业绩明明一直在增长。"</p>
<p>更令人关注的是，此次裁员的赔偿方案引发了员工群体的强烈不满。据称公司仅提供N+1的赔偿标准，且年终奖不予发放。多位员工表示将联合维权。</p>
<p>业内人士分析认为，在经济下行压力下，互联网行业的"降本增效"趋势仍将持续。但如此大规模的裁员是否会影响公司核心业务的发展，值得持续关注。</p>
<p>爆料专区已联系该公司公关部门，但对方以"内部调整，不便透露"为由拒绝回应。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Modern%20office%20building%20at%20dusk%20with%20dim%20lights%2C%20empty%20desks%20visible%20through%20windows%2C%20corporate%20layoff%20atmosphere%2C%20dramatic%20cloudy%20sky%2C%20cinematic%20mood%2C%20warm%20interior%20light%20contrast%20with%20cold%20exterior&width=1600&height=900&seq=article-02&orientation=landscape',
    imageWidth: 1600,
    imageHeight: 900,
    author: '科技观察员',
    publishDate: '2026-08-03',
    views: 985600,
    comments: 3820,
    tags: ['互联网大厂', '裁员', '科技行业', '内幕'],
    isHot: true,
    isExclusive: true,
    isVideo: false,
  },
  {
    id: 3,
    title: '独家视频：某网红餐厅后厨卫生状况触目惊心',
    slug: 'exclusive-video-restaurant-hygiene-scandal',
    category: 'meishi',
    excerpt: '爆料专区独家获取某知名网红火锅店后厨实拍视频，画面中卫生状况令人发指。该品牌在全国拥有超过200家门店，视频曝光后引发网络轩然大波。',
    content: `<p>触目惊心！爆料专区独家获取一段某知名网红火锅连锁店的后厨实拍视频，画面内容令人极度不适。</p>
<p>视频显示，该餐厅后厨存在多项严重卫生问题：食材随地堆放、老鼠在后厨乱窜、厨师未佩戴手套直接接触食材、洗碗池与洗菜池混用、过期食材仍在使用等。</p>
<p>这段长达三分钟的视频据称由该门店离职员工拍摄并独家提供给爆料专区。该员工表示："我在那里工作了半年，实在看不下去。管理层对卫生问题视而不见，一心只想赚钱。"</p>
<p>该网红火锅品牌在全国拥有超过200家门店，以"新鲜食材、健康美味"为宣传卖点，在社交媒体上拥有大量粉丝和良好口碑。此次视频曝光后，品牌方形象遭受重创。</p>
<p>视频发布两小时内即登上微博热搜第一，阅读量突破3亿。大量网友纷纷表示"再也不敢去吃了"、"这样的店就该查封"。多地市场监管部门已表示将介入调查。</p>
<p>爆料专区将持续跟进此事件的调查进展。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Dark%20and%20messy%20restaurant%20kitchen%20interior%20with%20poor%20hygiene%20conditions%2C%20dim%20yellow%20lighting%2C%20cluttered%20surfaces%2C%20documentary%20style%20photography%2C%20gritty%20realistic%20texture%2C%20unsettling%20atmosphere&width=1600&height=900&seq=article-03&orientation=landscape',
    imageWidth: 1600,
    imageHeight: 900,
    author: '吃货探员',
    publishDate: '2026-08-04',
    views: 2156000,
    comments: 12380,
    tags: ['网红餐厅', '卫生问题', '独家视频', '食品安全'],
    isHot: true,
    isExclusive: true,
    isVideo: true,
  },
  {
    id: 4,
    title: '某知名运动员被曝与俱乐部闹翻，转会传闻再起',
    slug: 'famous-athlete-transfer-rumors',
    category: 'tiyu',
    excerpt: '据内部消息人士透露，某国脚级球员与现效力俱乐部关系彻底破裂，已在更衣室公开表达离队意愿。多家豪门俱乐部已开始接触其经纪人。',
    content: `<p>体坛地震！据多位消息人士向爆料专区证实，某国家队主力球员与其现效力俱乐部之间的关系已降至冰点。</p>
<p>知情人士透露，矛盾的导火索是俱乐部在续约谈判中的态度问题。"俱乐部给出的续约条件完全没有诚意，而且主教练在新赛季计划中似乎已经不再把他放在核心位置，"该知情人士表示。</p>
<p>据悉，该球员已在更衣室内公开表达离队意愿，引发了队友和教练组的强烈震动。此事被俱乐部高层知晓后，双方关系进一步恶化。</p>
<p>消息传出后，多家欧洲豪门和国内顶级俱乐部已开始接触其经纪人。据估算，该球员目前的市场价值在5000万欧元左右。</p>
<p>"现在就看哪家俱乐部愿意匹配这个价格了，"一位体育经纪人分析道，"他的实力毋庸置疑，关键在于找到一个合适的体系和环境。"</p>
<p>爆料专区将密切关注转会市场的后续动态。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Empty%20football%20stadium%20locker%20room%20with%20dramatic%20lighting%2C%20single%20jersey%20hanging%20on%20hook%2C%20tense%20atmosphere%2C%20sports%20documentary%20style%2C%20cinematic%20composition%2C%20warm%20and%20cold%20light%20contrast&width=1600&height=900&seq=article-04&orientation=landscape',
    imageWidth: 1600,
    imageHeight: 900,
    author: '体育观察家',
    publishDate: '2026-08-03',
    views: 756200,
    comments: 2890,
    tags: ['体育', '转会', '足球', '内幕'],
    isHot: false,
    isExclusive: true,
    isVideo: false,
  },
  {
    id: 5,
    title: '某上市公司财务造假疑云，证监会已展开调查',
    slug: 'listed-company-financial-fraud-investigation',
    category: 'caijing',
    excerpt: '爆料专区获悉，某A股上市公司因涉嫌财务造假已被证监会立案调查。内部人士称该公司通过虚增营收、隐瞒关联交易等手段美化财报，涉及金额或达数十亿元。',
    content: `<p>资本市场再爆雷！爆料专区从多个独立信息源获悉，某A股上市公司因涉嫌严重财务造假，已被中国证监会正式立案调查。</p>
<p>据内部知情人士透露，该公司在过去三年中，通过虚增营业收入、隐瞒关联交易、提前确认收入等多种手段，对财务报表进行了系统性的粉饰。初步估算涉及金额可能高达数十亿元人民币。</p>
<p>"这不是简单的会计差错，而是一套精心设计的造假体系，"一位参与调查的人士向爆料专区表示，"公司的实际经营状况远比财报展现的要糟糕得多。"</p>
<p>该公司在A股市场属于知名企业，近年来股价表现活跃，吸引了大量散户投资者。如果造假坐实，将导致数万名投资者遭受重大损失。</p>
<p>目前证监会已对该公司股票实施了停牌处理，并开始全面核查其财务报表。多位法律界人士表示，如果调查结果证实造假，公司高管可能面临刑事追责。</p>
<p>爆料专区提醒广大投资者，资本有风险，投资需谨慎。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Modern%20financial%20district%20office%20building%20with%20blurred%20glass%20facade%2C%20dramatic%20sky%20with%20storm%20clouds%2C%20business%20scandal%20atmosphere%2C%20cinematic%20photography%2C%20cold%20blue%20and%20warm%20gold%20contrast%2C%20professional%20corporate%20setting&width=1600&height=900&seq=article-05&orientation=landscape',
    imageWidth: 1600,
    imageHeight: 900,
    author: '财经侦探',
    publishDate: '2026-08-02',
    views: 1320000,
    comments: 4560,
    tags: ['财务造假', '上市公司', '证监会', '资本市场'],
    isHot: true,
    isExclusive: true,
    isVideo: false,
  },
  {
    id: 6,
    title: '惊爆：某热门综艺节目被曝有剧本，选手淘汰早已内定',
    slug: 'reality-show-scripted-exposed',
    category: 'yule',
    excerpt: '一位曾参与某热门综艺节目制作的幕后工作人员向爆料专区独家爆料，称该节目的比赛结果完全由导演组预先设定，选手的"命运"早在录制前就已确定。',
    content: `<p>真人秀不"真人"？一位曾参与某热门竞技类综艺节目制作的幕后工作人员日前向爆料专区提供了一份详细的爆料材料，直指该节目存在严重的剧本操控问题。</p>
<p>该工作人员透露："每期节目录制前，导演组都会召开'剧本会'，讨论这一期谁该淘汰、谁该晋级、谁该制造冲突。选手们上台前就知道自己今天的'命运'。"</p>
<p>更令人震惊的是，据称节目组还会刻意剪辑选手的采访片段，将原本友好的对话拼接成"互怼"的效果，以制造话题热度。</p>
<p>"有时候看到选手在台上'真情流露'地哭，我（作为工作人员）心里其实很不好受，因为我们都知道那是在表演，"该爆料人表示。</p>
<p>此消息一出，立刻在网络上引发热议。不少观众表示"被骗了"、"以后再也不看这种节目了"。也有业内人士指出，综艺节目存在一定程度的"剧本化"是行业公开的秘密，但像这样完全操控比赛结果的，确实已经到了欺骗观众的地步。</p>
<p>节目组目前尚未就此事做出回应。</p>`,
    image: 'https://readdy.ai/api/search-image?query=TV%20studio%20behind%20the%20scenes%20with%20stage%20lights%20and%20cameras%2C%20empty%20judges%20panel%2C%20reality%20show%20set%20atmosphere%2C%20dramatic%20spotlight%20on%20empty%20stage%2C%20cinematic%20lighting%2C%20warm%20golden%20and%20deep%20shadow%20contrast&width=1600&height=900&seq=article-06&orientation=landscape',
    imageWidth: 1600,
    imageHeight: 900,
    author: '娱乐深喉',
    publishDate: '2026-08-04',
    views: 1876000,
    comments: 8920,
    tags: ['综艺节目', '剧本', '内定淘汰', '娱乐圈黑幕'],
    isHot: true,
    isExclusive: true,
    isVideo: false,
  },
  {
    id: 7,
    title: '新能源汽车自燃事件频发，某品牌被曝隐瞒安全隐患',
    slug: 'electric-vehicle-fire-safety-coverup',
    category: 'qiche',
    excerpt: '近期多地发生新能源汽车自燃事故，爆料专区获取内部文件显示，某知名新能源车企早在半年前就已发现电池设计缺陷，但选择隐瞒不报。',
    content: `<p>新能源汽车安全问题再次敲响警钟！近期全国多地接连发生多起新能源汽车自燃事故，其中某知名品牌涉及最多。</p>
<p>爆料专区独家获取的内部文件显示，该车企早在六个月前就已通过内部测试发现了电池模组存在的设计缺陷——在特定充电条件下，电池可能出现热失控风险。然而，该企业选择了"内部处理"而非公开召回。</p>
<p>"他们（车企高层）开的内部会议我参加了，当时就有人提出应该立即召回，但最终决定是'观察一段时间'，因为召回成本太高，而且会影响正在进行的IPO，"一位不愿具名的内部人士向爆料专区透露。</p>
<p>近半年来，该品牌车辆至少发生了7起自燃事件，涉及不同车型。所幸均未造成人员伤亡。但多位车主表示，在事故发生后，车企的态度是"极力压消息"，而非积极解决问题。</p>
<p>目前已有车主联合发起维权行动，并向国家市场监管总局递交了投诉材料。多地消防部门也已介入调查自燃原因。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Burned%20electric%20vehicle%20on%20urban%20street%20at%20night%2C%20fire%20damage%20visible%2C%20emergency%20response%20scene%2C%20dramatic%20lighting%2C%20documentary%20style%2C%20urban%20night%20setting%20with%20reflections%20on%20wet%20pavement&width=1600&height=900&seq=article-07&orientation=landscape',
    imageWidth: 1600,
    imageHeight: 900,
    author: '汽车调查员',
    publishDate: '2026-08-01',
    views: 654300,
    comments: 2340,
    tags: ['新能源汽车', '自燃', '安全隐患', '汽车行业'],
    isHot: false,
    isExclusive: true,
    isVideo: false,
  },
  {
    id: 8,
    title: '某知名教育机构被曝虚假宣传，教师资格造假成风',
    slug: 'education-institution-fake-qualifications',
    category: 'shehui',
    excerpt: '多位家长向爆料专区举报，某头部在线教育平台存在大量虚假宣传行为。记者调查发现，该平台宣传的"名师"中，多人学历和教学经历系伪造。',
    content: `<p>教育领域的诚信危机再次引发关注！多位焦虑的家长向爆料专区联合举报，称某头部在线教育平台存在严重的虚假宣传问题。</p>
<p>记者深入调查后发现，该平台对外宣传的"清北名师团"中，至少有15人的学历背景和教学经历存在造假嫌疑。其中，一位被包装为"清华毕业、十年教学经验"的王牌教师，实际只有大专学历，且之前从事的是销售工作。</p>
<p>"我们花了大几万给孩子报的课，冲着就是这些'名师'的名头，"一位愤怒的家长表示，"结果发现教的还不如学校老师好，一查才发现根本就是假的。"</p>
<p>该教育平台在广告中大量使用"名校毕业"、"高考状元导师"等宣传语，并配合精心包装的教师形象照，营造出高端专业的品牌形象。但实际上，部分教师甚至不具备教师资格证。</p>
<p>教育部门已表示将对此事展开调查。法律界人士指出，该平台的行为已涉嫌违反《广告法》和《消费者权益保护法》，家长可以联合提起集体诉讼。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Empty%20classroom%20with%20digital%20screens%20displaying%20online%20education%20platform%2C%20dim%20lighting%2C%20contrast%20between%20modern%20technology%20and%20traditional%20classroom%2C%20documentary%20style%2C%20warm%20afternoon%20light%20through%20windows&width=1600&height=900&seq=article-08&orientation=landscape',
    imageWidth: 1600,
    imageHeight: 900,
    author: '教育观察',
    publishDate: '2026-07-30',
    views: 543200,
    comments: 1890,
    tags: ['教育机构', '虚假宣传', '教师资格', '社会热点'],
    isHot: false,
    isExclusive: false,
    isVideo: false,
  },
  {
    id: 9,
    title: '某手机品牌新旗舰被曝严重发热问题，官方回应避重就轻',
    slug: 'smartphone-overheating-scandal',
    category: 'keji',
    excerpt: '多位用户反映某品牌最新旗舰手机存在严重发热问题，最高温度可达50度以上。爆料专区获得的内部测试报告显示，该问题源于芯片散热设计缺陷。',
    content: `<p>新机变"暖手宝"？多位购买了某品牌最新旗舰手机的用户近日集中反映，该机型在日常使用中存在异常发热问题。</p>
<p>"打一局游戏就烫得拿不住了，温度计实测表面温度超过50度，"一位用户向爆料专区展示了实测视频，"客服说'高性能运转时发热是正常的'，这不是糊弄人吗？"</p>
<p>爆料专区独家获得的内部测试报告显示，该机型采用的芯片在实际运行中功耗远超设计标准，而手机内部的散热结构不足以应对这一功耗水平。工程师在报告中明确标注了"散热风险"但该报告在产品发布前被高层"压了下来"。</p>
<p>面对用户投诉，品牌官方发布了一则简短声明，称"部分用户反映的发热情况属于正常范围内"，并建议用户"避免在充电时进行大型游戏"。这一回应被网友批评为"避重就轻"。</p>
<p>业内人士分析认为，该品牌为了首发最新芯片而压缩了测试周期，导致了此次大规模的质量问题。如果处理不当，可能会对该品牌的高端化战略造成严重打击。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20with%20thermal%20heat%20visualization%20effect%2C%20glowing%20red%20and%20orange%20heat%20waves%20on%20dark%20background%2C%20product%20photography%20style%2C%20dramatic%20lighting%2C%20modern%20tech%20aesthetic%2C%20close-up%20shot&width=1600&height=900&seq=article-09&orientation=landscape',
    imageWidth: 1600,
    imageHeight: 900,
    author: '数码先锋',
    publishDate: '2026-08-03',
    views: 876400,
    comments: 3450,
    tags: ['手机', '发热', '旗舰机', '产品质量'],
    isHot: false,
    isExclusive: true,
    isVideo: false,
  },
  {
    id: 10,
    title: '某知名主播被曝偷税漏税，金额惊人已被税务部门约谈',
    slug: 'famous-streamer-tax-evasion',
    category: 'caijing',
    excerpt: '爆料专区从税务系统内部获悉，某头部直播平台当红主播因涉嫌偷逃税款已被税务机关约谈。初步核查发现其通过多个壳公司转移收入，偷逃税额或超亿元。',
    content: `<p>直播行业再掀税务风暴！爆料专区从税务系统内部获悉，某拥有数千万粉丝的头部主播因涉嫌重大偷逃税款问题，已被当地税务机关正式约谈。</p>
<p>消息人士透露，税务部门在日常稽查中发现该主播及其关联企业存在大量异常财务往来。通过初步核查，发现该主播通过设立多家壳公司、虚构业务支出、隐匿直播打赏收入等多种手段，在近三年间涉嫌偷逃税款。</p>
<p>"偷逃的金额非常大，目前初步估算可能超过1亿元，"该消息人士表示，"这在全国范围内都属于重大案件。"</p>
<p>该主播在直播平台上以"豪爽大方"著称，经常在直播间展示豪车、名表等奢侈品。其年收入据估算在5亿元以上。如果偷逃税款罪名成立，不仅要补缴税款和罚款，还可能面临刑事处罚。</p>
<p>此前已有多个头部主播因偷逃税款被"封杀"，行业内的税务合规问题早已引发广泛关注。此案的发生再次敲响了警钟。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20home%20studio%20with%20professional%20streaming%20equipment%2C%20empty%20chair%20in%20front%20of%20monitors%2C%20dark%20atmosphere%2C%20cinematic%20lighting%2C%20spotlight%20on%20empty%20chair%2C%20wealthy%20lifestyle%20setting&width=1600&height=900&seq=article-10&orientation=landscape',
    imageWidth: 1600,
    imageHeight: 900,
    author: '财经侦探',
    publishDate: '2026-08-04',
    views: 1567000,
    comments: 6780,
    tags: ['直播', '偷税漏税', '税务', '主播'],
    isHot: true,
    isExclusive: true,
    isVideo: false,
  },
  {
    id: 11,
    title: '某爆款奶茶品牌被曝使用植脂末，"鲜奶"宣传涉嫌欺诈',
    slug: 'milk-tea-brand-fake-fresh-milk',
    category: 'meishi',
    excerpt: '记者暗访发现，某以"只用鲜奶"为卖点的网红奶茶品牌，实际在多家门店使用植脂末替代鲜奶。该品牌全国拥有超过500家门店，年营收超过30亿元。',
    content: `<p>奶茶爱好者们要当心了！爆料专区记者通过为期两周的暗访调查发现，某以"只用鲜奶，拒绝奶精"为宣传核心的头部奶茶品牌，其多家门店实际使用的是植脂末而非鲜奶。</p>
<p>暗访视频显示，该品牌门店工作人员在后厨制作奶茶时，向杯中倒入的是一种白色粉末——这正是食品工业中广泛使用的植脂末（俗称奶精）。而该品牌的门店宣传海报和社交媒体广告中，均明确标注"100%使用新鲜牛奶"。</p>
<p>"公司培训的时候就告诉我们，如果有人问，就说用的是鲜奶，"一位化名"小陈"的门店前员工向记者透露，"但实际上除了最贵的那款产品，其他用的都是奶精粉。"</p>
<p>食品专家指出，植脂末中含有反式脂肪酸，长期大量摄入会增加心血管疾病风险。而以"鲜奶"为卖点却实际使用植脂末，已涉嫌虚假宣传和消费欺诈。</p>
<p>该品牌全国拥有超过500家门店，年营收预计超过30亿元。消息曝光后，多个城市的市场监管部门已对其门店展开突击检查。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Milk%20tea%20shop%20interior%20with%20preparation%20area%2C%20white%20powder%20on%20counter%2C%20contrast%20between%20colorful%20menu%20and%20industrial%20kitchen%2C%20documentary%20style%2C%20warm%20shop%20lighting%2C%20realistic%20texture&width=1600&height=900&seq=article-11&orientation=landscape',
    imageWidth: 1600,
    imageHeight: 900,
    author: '吃货探员',
    publishDate: '2026-08-02',
    views: 987300,
    comments: 4320,
    tags: ['奶茶', '植脂末', '虚假宣传', '食品安全'],
    isHot: false,
    isExclusive: true,
    isVideo: true,
  },
  {
    id: 12,
    title: '某知名游戏公司内部贪腐案曝光，涉案高管已被带走',
    slug: 'game-company-corruption-scandal',
    category: 'shehui',
    excerpt: '据多位知情人士证实，某头部游戏公司多名高管因涉嫌贪污受贿已被司法机关带走调查。内部人士称贪腐金额巨大，涉及采购、市场推广、IP授权等多个环节。',
    content: `<p>游戏圈大地震！爆料专区从多个独立信息源确认，某头部游戏公司近日发生大规模内部贪腐案件，多名高管已被带走调查。</p>
<p>据了解，此次案件涉及的贪腐行为持续多年，覆盖了公司运营的多个关键环节。具体包括：采购环节的"回扣门"、市场推广费用的虚假报销、IP授权合作中的利益输送，以及内部职位的"买官卖官"。</p>
<p>"涉案金额非常巨大，目前初步估算可能超过10亿元，"一位接近调查的消息人士向爆料专区透露，"这可能是中国游戏行业有史以来最大的内部贪腐案件。"</p>
<p>该公司在业内以高福利和"家文化"著称，员工对公司普遍具有较高的认同感。此次事件爆出后，内部员工社群一片哗然。</p>
<p>"平时满口'家人文化'，背地里却在干这种事，太让人失望了，"一位不愿具名的员工表示。</p>
<p>公司官方暂未发布正式声明。但据内部消息，董事会已紧急召开会议，将全面配合司法机关的调查。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Modern%20game%20company%20office%20building%20with%20glass%20walls%2C%20dim%20lighting%20in%20some%20windows%2C%20corporate%20scandal%20atmosphere%2C%20stormy%20sky%2C%20cinematic%20photography%2C%20cold%20blue%20and%20warm%20interior%20light&width=1600&height=900&seq=article-12&orientation=landscape',
    imageWidth: 1600,
    imageHeight: 900,
    author: '社会观察家',
    publishDate: '2026-08-01',
    views: 1102000,
    comments: 3890,
    tags: ['游戏公司', '贪腐', '高管', '社会新闻'],
    isHot: false,
    isExclusive: true,
    isVideo: false,
  },
];

export function getArticleById(id: number): Article | undefined {
  return articles.find(a => a.id === id);
}

export function getArticlesByCategory(category: string): Article[] {
  if (category === 'all') return articles;
  return articles.filter(a => a.category === category);
}

export function getHotArticles(): Article[] {
  return articles.filter(a => a.isHot);
}

export function getLatestArticles(limit: number = 6): Article[] {
  return [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, limit);
}

export function getRelatedArticles(articleId: number, limit: number = 3): Article[] {
  const article = getArticleById(articleId);
  if (!article) return [];
  return articles.filter(a => a.id !== articleId && a.category === article.category).slice(0, limit);
}